// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"92d30384","239":"4fb178c3","455":"8bda4bdb"}[chunkId] + ".chunk.js";
};